import React from 'react';
import { FaFile } from 'react-icons/fa';

/**
 * ツールの利用手順コンポーネントです。
 * @returns {JSX.Element} - JSX要素
 */
const InstructionsForUsing: React.FC = () => {
  return (
    <>
      <div className="rounded-3 align-baseline" style={{backgroundColor: '#ffe4b5'}}>
        <h3 className="h5 py-2 px-2 text-primary fw-bold">電子特殊申請書類作成支援ツール利用手順</h3>
      </div>
      <div className="px-3">
        <div className="my-2">以下の手順で電子特殊申請で提出する手続書面を作成してください（利用者マニュアルは<a href="../../common/doc/manual.pdf" target='_blank'><FaFile />こちら</a>）。</div>
        <ol className="mx-lg-3 mx-1">
          <li>Webフォームの各項目を日本語で入力する</li>
          <li>手続書類のPDFデータを生成し、ファイルとして保存する</li>
        </ol>
        <div className="my-2">保存したPDFファイルを、電子出願ソフトの〔書類作成〕で提出物件として添付してください。</div>
        <div className="mt-3 mb-2 small">※ 包括委任状は委任者及び選任した代理人両者の合意がなければ作成できません。ご理解の上、ご利用ください。</div>
      </div>
    </>
  );
}

export default InstructionsForUsing;